module.exports = __webpack_public_path__ + "static/media/withoutServices.10df1f31.svg";